import { createPortal } from 'react-dom';
import React, { useEffect, useState } from 'react';

const FilterDropdown = ({ isActive, buttonRef, dropdownRef, filter_key, children }) => {
  const initial = {
    top: 0,
    left: 0,
  };
  const [position, setPosition] = useState(initial);
  const [innerWidth, setInnerWidth] = useState(window.innerWidth);

  const handleResize = () => {
    setInnerWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (buttonRef && buttonRef.current && isActive) {
      const rect = buttonRef.current.getBoundingClientRect();
      const dropdownRect = dropdownRef.current.getBoundingClientRect();

      let left: any;

      if (rect.left + scrollX <= 65) {
        left = 0;
      } else {
        // Check if dropdown goes beyond right edge
        if (rect.left + dropdownRect.width > innerWidth) {
          // Position dropdown so right edge aligns with trigger
          left = rect.right - dropdownRect.width + window.scrollX;
        } else {
          // Default: align left edge with trigger
          left = rect.left + window.scrollX;
        }
      }

      const top = rect.bottom + window.scrollY; // always below trigger
      setPosition({
        top: top,
        left: left,
      });
    }
  }, [buttonRef, isActive, innerWidth]);

  return createPortal(
    <div
      ref={dropdownRef}
      className={`dropdown ${filter_key} ${isActive ? 'active' : ''}`}
      style={{
        position: 'absolute',
        top: position.top,
        left: position.left,
        zIndex: 10000,
      }}
    >
      {children}
    </div>,
    document.body
  );
};

export { FilterDropdown };
